import React, { FC } from 'react';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { fullName } from 'utils/full-name';
import { getThumbnailUrl } from 'utils/get-thumbnail-url';
import { DescriptionWithAvatar } from './description-with-avatar';

export const UserDetail: FC<{ user: User; referenceTeamName?: string }> = ({
  user,
  referenceTeamName,
}) => {
  const userName = fullName(user);

  return (
    <DescriptionWithAvatar
      avatar={
        <Avatar
          src={getThumbnailUrl(user.photoUrl)}
          name={userName}
          size={40}
        />
      }
      title={userName}
      subtitle={referenceTeamName ?? user.role?.roleName}
    />
  );
};
